import { hasPermission } from '../utils/hasPermission'
import PropTypes from 'prop-types'
import { Component } from 'react'

export default class PermissionGuard extends Component {
  static propTypes = {
    children: PropTypes.node,
    object: PropTypes.string.isRequired,
    operation: PropTypes.string.isRequired,
    permissions: PropTypes.object
  }

  static defaultProps = {
    permissions: {}
  }

  render() {
    const { children, permissions, object, operation } = this.props

    if (permissions == null) {
      return null
    }

    return hasPermission(permissions, operation, object) ? children : null
  }
}



// WEBPACK FOOTER //
// ../src/components/PermissionGuard.js